<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <div class="halfWidthConfigurationInput">
          @if (riserConnectionSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Riser Connection:</label>
              <select class="halfWidthInputField" #riserConnectionInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserConnectionSelection.Name)"
                (change)="selectionChanged(riserConnectionSelection, riserConnectionInput.value)"
                [value]="riserConnectionSelection.Value.toString()">
                @for (allowable of riserConnectionSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserConnectionSelection.Value && riserConnectionSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (supplyTypeSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Supply Air Type:</label>
              <select class="halfWidthInputField" #supplyTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyTypeSelection.Name)"
                (change)="selectionChanged(supplyTypeSelection, supplyTypeInput.value)"
                [value]="supplyTypeSelection.Value.toString()">
                @for (allowable of supplyTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyTypeSelection.Value && supplyTypeSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (opposedBladeDamperSelection || sightBaffleSelection) {
            <div class="modConnectionRow">
              @if (opposedBladeDamperSelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(opposedBladeDamperSelection.Name)"
                  for="opposedBladeDamperInput" class="halfWidthInputLabel">Opposed Blade Damper:</label>
                  <input type="checkbox" class="checkboxInput" id="opposedBladeDamperInput"
                    #opposedBladeDamperInput [checked]="'true' === opposedBladeDamperSelection.Value"
                    (change)="selectionChanged(opposedBladeDamperSelection, opposedBladeDamperInput.checked.toString())">
                </span>
              }
              @if (sightBaffleSelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(sightBaffleSelection.Name)"
                  for="sightBaffleInput" class="modConnectionCheckboxLabel">Sight Baffle:</label>
                  <input type="checkbox" class="checkboxInput" id="sightBaffleInput"
                    #sightBaffleInput [checked]="'true' === sightBaffleSelection.Value"
                    (change)="selectionChanged(sightBaffleSelection, sightBaffleInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (paintOptionsSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Paint Options:</label>
              <select class="halfWidthInputField" #paintOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
                (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
                [value]="paintOptionsSelection.Value.toString()">
                @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
        <div class="halfWidthConfigurationInput">
          @if (pipeDetailImagePath() && pipeDetailImagePath().length > 0) {
            <img class="detailImage"
              [src]="pipeDetailImagePath()" alt="PipeDetailImage"/>
          }
          @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
            <img class="detailImage"
              [src]="handArrangementImagePath()" alt="ArrangementImage"/>
          }
        </div>
      </div>
    </div>
  }
</div>
